import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core'
import { Observable, of } from 'rxjs';
import { tap, catchError, mergeMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AuthStore } from './modules/auth/state/auth.store';
import { AuthQuery } from './modules/auth/state/auth.query';
import { AuthService } from './modules/auth/state/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class DefaultInterceptor implements HttpInterceptor {

  jwtService = new JwtHelperService();

  constructor(private injector: Injector, private authStore: AuthStore, private authQuery: AuthQuery, private authService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler)
    : Observable<HttpEvent<any>> {
    // tslint:disable-next-line: no-non-null-assertion
    if (this.authQuery.auth){

      // Check expired token
      if (this.jwtService.isTokenExpired(this.authQuery.auth.token)){
        this.authService.logout();
      }
      return this.handleResponse(this.injectAuthHeader(req, this.authQuery.auth.token), next);
    }
    else{
      return next.handle(req);
    }

  }

  private injectAuthHeader(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      }
    });
  }


  private handleResponse(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req);
  }
}

